export default class GetInfo {
    static getCustomerId() {
        let cust_Id = localStorage.getItem("customerId");
        cust_Id = (cust_Id == "null" || cust_Id == "undefined" || cust_Id === null || cust_Id === undefined || cust_Id==="") ? 0 : cust_Id;
        return cust_Id;
    }
}